import { useState } from "react";
import { sbUpdatePass } from '../services/supabase-api';
import { Sel, Inp } from './ui/FormControls';

// ── ADMIN: AJUSTES ──────────────────────────────────────────────
export const AjustesSection = ({ currentUser }) => {
  const [pwForm, setPwForm] = useState({ target: "operario@warehauseplan.com", newPass: "", confirm: "" });
  const [pwMsg, setPwMsg] = useState("");

  const cambiarPassword = async () => {
    if (!pwForm.newPass || pwForm.newPass.length < 4) { setPwMsg("❌ La contraseña debe tener al menos 4 caracteres."); return; }
    if (pwForm.newPass !== pwForm.confirm) { setPwMsg("❌ Las contraseñas no coinciden."); return; }
    const ok = await sbUpdatePass(pwForm.target, pwForm.newPass);
    if (ok) {
      setPwMsg(`✅ Contraseña actualizada correctamente.`);
      setPwForm(p => ({ ...p, newPass: "", confirm: "" }));
      setTimeout(() => setPwMsg(""), 3000);
    } else {
      setPwMsg("❌ Error al actualizar la contraseña.");
    }
  };

  return (
    <div className="bg-white rounded-xl shadow p-4 space-y-4">
      <h2 className="font-bold text-gray-800 border-b pb-2">⚙️ Gestión de contraseñas</h2>
      <p className="text-xs text-gray-500">Los cambios se guardan en Supabase y son permanentes en cualquier dispositivo.</p>
      <Sel label="Usuario" value={pwForm.target} onChange={v => setPwForm(p => ({ ...p, target: v }))} options={currentUser?.almacen_id === "cb60fe34-e079-4e36-8bd9-f5f5c3a1f21c"
  ? ["operario@warehauseplan.com", "admin@warehauseplan.com", "operador@warehauseplan.com"]
  : ["operario@clientedemo.com", "admin@clientedemo.com", "operador@clientedemo.com"]} />
      <Inp label="Nueva contraseña" type="password" value={pwForm.newPass} onChange={v => setPwForm(p => ({ ...p, newPass: v }))} placeholder="Mínimo 4 caracteres" />
      <Inp label="Confirmar contraseña" type="password" value={pwForm.confirm} onChange={v => setPwForm(p => ({ ...p, confirm: v }))} placeholder="Repite la contraseña" />
      {pwMsg && <p className={`text-sm font-semibold text-center ${pwMsg.startsWith("✅") ? "text-green-600" : "text-red-500"}`}>{pwMsg}</p>}
      <button onClick={cambiarPassword} className="w-full bg-green-600 text-white font-bold py-3 rounded-xl hover:bg-green-700 transition-all">
        Guardar contraseña
      </button>
    </div>
  );
};
